import React, { useEffect, useState } from "react";
import "./Slots.scss";
import { RootState, useAppDispatch, useAppSelector } from "../../cache/store";
import HandlerError from "../../helper/HandlerError";
import alertMsg from "components/alert-message/alert-message";
import game3rdApi from "apis/game3rdApi";
import { login } from "features/authSlice";
import { useSearchParams } from "react-router-dom";
import { dgList } from "interfaces/listGameDG";
import { JiliGame } from "interfaces/jiliList";
import { PgSoftGame } from "interfaces/pgsList";
import { PtGame } from "interfaces/ptList";
import { tryImg } from "utils/safeImage";

interface IGame3RD {
    id: string;
	img: string;
    port: string;
    login: string;
	isActive: boolean;
    valSname: string;
    valSvalue:  string;
}

const listSlots: IGame3RD[] = [
    {
		id:"DS",
		img: `slotds.png`,
		isActive: false,
		port: "DSGameLoginBean_DSLogin",
        login: "DSGameBean_DSGetLink",
        valSname: "Slots",
        valSvalue:  "ds_slot"
	},
	{
		id:"HABA",
		img: `haba_pic.png`,
		isActive: false,
		port: "habaSlot_list",
        login: "habaLogin_login",
        valSname: "Slots",
        valSvalue:  "habanero_slot"
	},
	{
		id:"PRAG",
		img: `prag_icon.png`,
		isActive: false,
		port: "pragmatic_list",
        login: "launchGame3rd",
        valSname: "LiveCasino",
        valSvalue:  "pragmatic_casino"
	},
	{
		id:"JILI",
		img: `jili_icon.png`,
		isActive: false,
		port: "jili_list", // API danh sách game JILI (backend trả {games:[{gameId,name,...}]})
        login: "launchGame3rd",
        valSname: "Slots",
        valSvalue:  "jili_slot"
	},
	{
		id:"PGSOFT",
		img: `pg_icon.png`,
		isActive: false,
		port: "pgs_list", // API danh sách game PG Soft (backend trả {games:[{gameId,gameCode,name,nameVi,...}]})
        login: "launchGame3rd",
        valSname: "Slots",
        valSvalue:  "pgs_slot" // sảnh riêng của PG Soft (loginEntry3rdGame {sname:'Slots', svalue:'pgs_slot'} → code 0)
	},
	{
		id:"PT",
		img: `pt_icon.png`,
		isActive: false,
		port: "pt_list", // API danh sách game Playtech (backend trả {games:[{gameCode,name,nameVi,category,...}]})
        login: "launchGame3rd",
        valSname: "Slots",
        valSvalue:  "pt_slot" // sảnh riêng Playtech (loginEntry3rdGame {sname:'Slots', svalue:'pt_slot'} → code 0)
	},
];

interface labelGameHaba {
    title: string,
    helpLink: string,
    keyName: string,
    keyNameStr: string,
    key: string
}

interface labelGamePRAG {
    image: string,
    key: string,
    keyNameStr: string;
    title: string;
}
interface keyName {
    id: string;
    valSname: string;
    valSvalue: string;
    keyLogin: string;
}

const Slots: React.FC = () => {
	const dispatch = useAppDispatch();
    const { isLogged } = useAppSelector((state: RootState) => state.auth);
    const [listGameHaba, setListGameHaba] = useState<labelGameHaba[]>([{} as labelGameHaba]);
    const [listGameSlots, setListGameSlots] = useState<labelGamePRAG[]>([{} as labelGamePRAG]);
    const [listGameJili, setListGameJili] = useState<JiliGame[]>([]);
    const [jiliCat, setJiliCat] = useState<string>('1'); // 1 = Slot, 5 = Bắn cá
    const [listGamePgs, setListGamePgs] = useState<PgSoftGame[]>([]);
    const [listGamePt, setListGamePt] = useState<PtGame[]>([]);
    const [ptCat, setPtCat] = useState<string>('slot'); // 'slot' | 'live' (Playtech)
    const [keyName, setKeyName] = useState<keyName>({} as keyName);
    const [searchParams] = useSearchParams();
    const idgame: string = searchParams.get('idgame') || 'DS'; //mặc định xs nhanh 1s
    const catParam: string = searchParams.get('cat') === '5' ? '5' : '1'; // 1=Slot, 5=Bắn cá (từ URL, cho JILI)
    const ptCatParam: string = searchParams.get('cat') === 'live' ? 'live' : 'slot'; // Playtech: slot | live (từ URL)

    // tải danh sách game JILI theo category (1=Slot, 5=Bắn cá)
    const loadJiliGames = async (category: string) => {
        const { data } = await game3rdApi.Login3RD({ action: 'jili_list', category });
        if (!data.msg && Array.isArray(data.games)) {
            setListGameJili(data.games);
        } else {
            setListGameJili([]);
        }
    };

    const switchJiliCat = (category: string) => {
        if (category === jiliCat) return;
        setJiliCat(category);
        setListGameJili([]);
        loadJiliGames(category);
    };

    // tải danh sách game PG Soft (pgs_list, không cần đăng nhập)
    const loadPgsGames = async () => {
        const { data } = await game3rdApi.Login3RD({ action: 'pgs_list' });
        if (!data.msg && Array.isArray(data.games)) {
            setListGamePgs(data.games);
        } else {
            setListGamePgs([]);
        }
    };

    // tải danh sách game Playtech theo category (slot | live)
    const loadPtGames = async (category: string) => {
        const { data } = await game3rdApi.Login3RD({ action: 'pt_list', category });
        if (!data.msg && Array.isArray(data.games)) {
            setListGamePt(data.games);
        } else {
            setListGamePt([]);
        }
    };

    const switchPtCat = (category: string) => {
        if (category === ptCat) return;
        setPtCat(category);
        setListGamePt([]);
        loadPtGames(category);
    };

    useEffect(() => {
        setJiliCat(catParam);
        setPtCat(ptCatParam);
        listSlots.forEach((item) => {
            item.isActive = false;
            if(item.id === idgame) {
                item.isActive = true;
                if (item.id === 'JILI') {
                    // deep-link (vd từ menu Bắn Cá: ?idgame=JILI&cat=5) — dùng cat từ URL trực tiếp.
                    // Phụ thuộc cả catParam: đổi slot↔bắn cá (cùng idgame=JILI) vẫn load lại list.
                    setListGameHaba([]);
                    setListGameSlots([]);
                    setKeyName({ id: item.id, valSname: item.valSname, valSvalue: item.valSvalue, keyLogin: item.login });
                    loadJiliGames(catParam);
                } else if (item.id === 'PGSOFT') {
                    // deep-link PG Soft (pgs_list công khai) — tải list ngay giống JILI.
                    setListGameHaba([]);
                    setListGameSlots([]);
                    setListGameJili([]);
                    setKeyName({ id: item.id, valSname: item.valSname, valSvalue: item.valSvalue, keyLogin: item.login });
                    loadPgsGames();
                } else if (item.id === 'PT') {
                    // deep-link Playtech (vd từ menu Live Casino: ?idgame=PT&cat=live) — dùng cat từ URL.
                    // Phụ thuộc ptCatParam: đổi slot↔live (cùng idgame=PT) vẫn load lại list.
                    setListGameHaba([]);
                    setListGameSlots([]);
                    setListGameJili([]);
                    setListGamePgs([]);
                    setKeyName({ id: item.id, valSname: item.valSname, valSvalue: item.valSvalue, keyLogin: item.login });
                    loadPtGames(ptCatParam);
                } else {
                    onClickGame(item);
                }
            }
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idgame, catParam, ptCatParam])

    const loadListGamePragmatic = (data: any) => {
        let listGames: any = [];
        for (let i = 0; i < data.gameName.length; i++) {
            const keyNameStr: string = data.keyName[i].substr(data.keyName[i].lastIndexOf('/') + 1);
            const pragmaticItem: any = {};
            pragmaticItem['title'] = data.gameName[i];
            pragmaticItem['helpLink'] = `https://help-a.insvr.com/game/?keyname=${keyNameStr}&locale=${data.locale}`;
            pragmaticItem['image'] = data.keyName[i];
            pragmaticItem['keyNameStr'] = keyNameStr.replace('_200x200_NB.png', '');
            pragmaticItem['key'] = 'pragmatic';
            listGames.push(pragmaticItem);
        }
        setListGameSlots(listGames);
      }
    
	const onClickGame = async (game: IGame3RD) => {
		if (!isLogged) {
			alertMsg('Vui lòng đăng nhập');
		} else {
            listSlots.forEach((item) => {
                item.isActive = false;
                if(item.id === game.id) {
                    item.isActive = true;
                }
            })
            // JILI: gọi API jili_list theo category đang chọn (1=Slot, 5=Bắn cá) → list động
            if (game.id === "JILI") {
                setListGameHaba([]);
                setListGameSlots([]);
                setKeyName({id: game.id, valSname: game.valSname, valSvalue: game.valSvalue, keyLogin: game.login});
                loadJiliGames(jiliCat);
                return;
            }
            // PG Soft: gọi pgs_list → list động
            if (game.id === "PGSOFT") {
                setListGameHaba([]);
                setListGameSlots([]);
                setListGameJili([]);
                setKeyName({id: game.id, valSname: game.valSname, valSvalue: game.valSvalue, keyLogin: game.login});
                loadPgsGames();
                return;
            }
            // Playtech: gọi pt_list theo category đang chọn (slot | live) → list động
            if (game.id === "PT") {
                setListGameHaba([]);
                setListGameSlots([]);
                setListGameJili([]);
                setListGamePgs([]);
                setKeyName({id: game.id, valSname: game.valSname, valSvalue: game.valSvalue, keyLogin: game.login});
                loadPtGames(ptCat);
                return;
            }
			const { data } = await game3rdApi.Login3RD({action: game.port});
            HandlerError(
                data,
                async () => {
                    if(!data.msg) {
                        setListGameHaba([]);
                        setKeyName({id: game.id, valSname: game.valSname, valSvalue: game.valSvalue, keyLogin: game.login});
                        if(game.id === "HABA") {
                            ListGame3RD(data);
                        } else if(game.id === "PRAG") {
                            loadListGamePragmatic(data);
                        } else if(game.id === "DS") {
                            const idgameSet = new Set(dgList[0].map(item => item.idgame));
                            const filteredGames = data.games.filter((game: any) => idgameSet.has(game.keyName));
                            setListGameHaba(filteredGames);
                        }
                    }
                },
                "OpenSlotGame"
            )
		}
	};

    const openGameSlot = async (items: any) => {
        const payload = {
            sname: keyName.valSname,
            svalue: keyName.valSvalue
        }
        const { data } = await game3rdApi.sysGame3rdLoginBean(payload);
        HandlerError(
            data,
            () => {
                if(data.msg || data.message) {
                    alertMsg(data.msg || data.message);
                    return;
                }
                playGameSlost(items);

            },
            "sysGame3rdLoginBean"
        )
    }

    const playGameSlost = async (item: any) => {
        if (!isLogged) {
			dispatch(login(true));
		} else {
            let getPayload;
            let payload = {
                action: keyName.keyLogin
            }
            let payloadDs = {
                action: keyName.keyLogin,
                gameCode: item.keyName,
                backUrl: window.location.href
            }
            let payloadPrag = {
                gameId: "PRAG_SLOT",
                code: item.keyNameStr,
                action: keyName.keyLogin,
            };
            let payloadJili = {
                gameId: "JILI",
                code: item.gameId, // = games[i].gameId từ jili_list
                action: keyName.keyLogin,
                device: "web", // bản web desktop (khớp mục 2.2 collection)
            };
            let payloadPgs = {
                gameId: "PGSOFT",
                code: item.gameId, // = games[i].gameId từ pgs_list
                action: keyName.keyLogin,
                device: "web",
            };
            let payloadPt = {
                gameId: "PT",
                code: item.gameCode, // Playtech dùng gameCode làm code (không có gameId số)
                action: keyName.keyLogin,
                device: "web",
                category: ptCat, // 'slot' | 'live' theo tab đang chọn
            };
            if(keyName.id === "DS") {
                getPayload = payloadDs;
            } else if(keyName.id === "PRAG") {
                getPayload = payloadPrag;
            } else if(keyName.id === "JILI") {
                getPayload = payloadJili;
            } else if(keyName.id === "PGSOFT") {
                getPayload = payloadPgs;
            } else if(keyName.id === "PT") {
                getPayload = payloadPt;
            } else {
                getPayload = payload;
            }
            const { data } = await game3rdApi.LoginSlot(getPayload);
            if(data.msg || data.message) {
                alertMsg(data.msg || data.message);
                return;
            }
            if (keyName.id === "HABA") {
                const linkHaba = `${data.gameLaunchUrl}?ts=session&brandid=${data.branchID}&keyname=${item.keyNameStr}&token=${data.userToken}&mode=${data.modePlay}&locale=${data.locale}`;
                window.open(linkHaba, "__blank");
            } else if (keyName.id === "PRAG") {
                const linkPrag = `${data.listUrl[0]}`;
                window.open(linkPrag, "__blank");
            } else if (keyName.id === "DS") {
                const linkDs = `${data.forwardGame}`;
                window.open(linkDs, "__blank");
            } else if (keyName.id === "JILI") {
                const linkJili = `${data.listUrl[0]}`;
                window.open(linkJili, "_blank"); // mở tab mới (giữ nguyên trang web)
            } else if (keyName.id === "PGSOFT") {
                // PG Soft trả HTML (listUrl rỗng) → ghi nguyên HTML vào tab mới, không parse lấy link.
                if (data.html) {
                    const w = window.open('', '_blank');
                    if (w) {
                        w.document.open();
                        w.document.write(data.html);
                        w.document.close();
                    } else {
                        alertMsg('Trình duyệt đang chặn cửa sổ bật lên. Vui lòng cho phép pop-up rồi thử lại.');
                    }
                }
            } else if (keyName.id === "PT") {
                // Playtech: api trả link trang vào game (ptlaunch.cgi, hiệu lực 2 phút) trong listUrl.
                // Không ghi HTML vào tab about:blank: thư viện đăng nhập Playtech cần trang có domain thật (nếu không sẽ đứng ở "Đang tải game").
                if (Array.isArray(data.listUrl) && data.listUrl[0]) {
                    const w = window.open(data.listUrl[0], "_blank");
                    if (!w) {
                        alertMsg('Trình duyệt đang chặn cửa sổ bật lên. Vui lòng cho phép pop-up rồi thử lại.');
                    }
                }
            }
        }
    }


	const ListGame3RD = async (listGame: any) => {
       let getListGameHaba: { title: any; helpLink: string; keyName: any; keyNameStr: any; key: string; }[] = [];
       listGame["gameName"].forEach((elm: any, idx: number) => {
            const keyNameStr = listGame.keyName[idx].substr(listGame.keyName[idx].lastIndexOf('/') + 1);
            const habaItem = {
                title: listGame.gameName[idx],
                helpLink: `https://help-a.insvr.com/game/?keyname=${keyNameStr}&locale=${elm.locale}`,
                keyName: listGame.keyName[idx],
                keyNameStr: keyNameStr,
                key: 'Haba'
            };
            getListGameHaba.push(habaItem);
       });

       setListGameHaba(getListGameHaba);
    }

	return (
        <>
            <div className="listSlot">
                <div className="inner">
                    {listSlots.map((item, idx) => (
                        <div onClick={() => onClickGame(item)} key={idx} className={item.isActive ? "active itemGameList" : "itemGameList"}>
                            <img src={tryImg(() => require(`assets/images/slots/${item.img}`))} alt="" />
                        </div>
                    ))}
                </div>
            </div>

            { keyName.id === "JILI" && (
                <div className="jili-cat-toggle">
                    <button type="button" className={jiliCat === '1' ? 'active' : ''} onClick={() => switchJiliCat('1')}>Slot</button>
                    <button type="button" className={jiliCat === '5' ? 'active' : ''} onClick={() => switchJiliCat('5')}>Bắn cá</button>
                </div>
            )}

            { keyName.id === "PT" && (
                <div className="jili-cat-toggle">
                    <button type="button" className={ptCat === 'slot' ? 'active' : ''} onClick={() => switchPtCat('slot')}>Slot</button>
                    <button type="button" className={ptCat === 'live' ? 'active' : ''} onClick={() => switchPtCat('live')}>Live Casino</button>
                </div>
            )}

            <div className="slots-list">

                { (keyName.id === "PRAG") && listGameSlots.map((item, idx) => (
                    <div className="item" key={idx}>
                        <img src={`${item.image}`} onClick={() => openGameSlot(item)} alt="" />
                    </div>
                ))}

                { keyName.id === "HABA" && listGameHaba.map((item, idx) => (
                    <div className="item" key={idx}>
                        <img src={require(`assets/images/slots/games-img/${item.keyNameStr}.png`)} onClick={() => openGameSlot(item)} alt="" />
                    </div>
                ))}

                { keyName.id === "DS" && listGameHaba.map((item, idx) => (
                    <div className="item" key={idx}>
                        <img src={require(`assets/images/slots/ds/${item.keyName}.png`)} onClick={() => openGameSlot(item)} alt="" />
                    </div>
                ))}

                { keyName.id === "JILI" && listGameJili.map((item, idx) => (
                    <div className="item jili-item" key={idx} onClick={() => openGameSlot(item)}>
                        {/* ảnh game lấy từ CDN chính chủ: JL_200x200_GameID<NNN>_en-US.png (NNN = gameId 3 chữ số) */}
                        <img
                            src={`https://lux-cdn.pages.dev/slots/jili/JL_200x200_GameID${String(item.gameId).padStart(3, '0')}_en-US.png`}
                            alt={item.name}
                            onError={(e) => { (e.currentTarget as HTMLImageElement).style.visibility = 'hidden'; }}
                        />
                        <span className="jili-name">{item.name}</span>
                    </div>
                ))}

                { keyName.id === "PGSOFT" && listGamePgs.map((item, idx) => (
                    <div className="item jili-item" key={idx} onClick={() => openGameSlot(item)}>
                        {/* ảnh game lấy từ CDN: slots/pg/<gameCode>.png (dùng gameCode, không phải gameId) */}
                        <img
                            src={`https://lux-cdn.pages.dev/slots/pg/${item.gameCode}.png`}
                            alt={item.nameVi || item.name}
                            onError={(e) => { (e.currentTarget as HTMLImageElement).style.visibility = 'hidden'; }}
                        />
                        <span className="jili-name">{item.nameVi || item.name}</span>
                    </div>
                ))}

                { keyName.id === "PT" && listGamePt.map((item, idx) => (
                    <div className="item jili-item" key={idx} onClick={() => openGameSlot(item)}>
                        {/* ảnh game từ CDN: slot → slots/pt/<gameCode>.png, live → live/pt/<gameCode>.png */}
                        <img
                            src={`https://lux-cdn.pages.dev/${ptCat === 'live' ? 'live' : 'slots'}/pt/${item.gameCode}.png`}
                            alt={item.nameVi || item.name}
                            onError={(e) => { (e.currentTarget as HTMLImageElement).style.visibility = 'hidden'; }}
                        />
                        <span className="jili-name">{item.nameVi || item.name}</span>
                    </div>
                ))}
            </div>
        </>
	);
};

export default Slots;
